export default "__VITE_ASSET__DP6qDphk__"